

export const isLootBox = (itemType: string): boolean => ['lootbox', 'shard_lootbox'].includes(itemType);
